import fetch from '@/plugin/axios'

export function addTos (query) {
  return fetch({
    url: '/api/goods/admin/category/add',
    method: 'Post',
    data: query
  })
}

export function getSee (query) {
  return fetch({
    url: '/api/goods/admin/category/list',
    method: 'Post',
    data: query
  })
}

export function getDefaults (id) {
  return fetch({
    url: `/api/goods/admin/category/set/default/${id}`,
    method: 'Post'
  })
}

export function getModify (query, id) {
  return fetch({
    url: `/api/goods/admin/category/edit/${id}`,
    headers: { 'Content-Type': 'application/json' },
    method: 'Post',
    data: query
  })
}

export function getDeletes (id) {
  return fetch({
    url: `/api/goods/admin/category/${id}`,
    // headers:{'Content-Type':'application/json'},
    method: 'DELETE'
  })
}
// 获取七牛token
export function getToken () {
  return fetch({
    url: '/api/common/oss/token',
    method: 'Get'
  })
}
// 上传文件到七牛
export function getUpload () {
  return fetch({
    url: '/api/common/oss/upload',
    method: 'Post'
  })
}

// 产品分类
export function getClassificationd () {
  return fetch({
    url: '/api/goods/admin/category/options',
    method: 'Get'
  })
}
// 首页链接
export function getHttps () {
  return fetch({
    url: '/api/common/skip-type/list',
    method: 'Get'
  })
}
